// Original JavaScript code by Chirp Internet: www.chirp.com.au
// Please acknowledge use of this code by including this header.
define(["require", "exports", "./HilitorClassRegistry", "./UnicodeUtility"], function (require, exports, HilitorClassRegistry_1, UnicodeUtility_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Hilitor = /** @class */ (function () {
        function Hilitor(targetNode) {
            /**
             * characters used to break up the input string into words
             */
            this.breakRegExp = new RegExp('[^\\w\'-]+', 'g');
            /**
             * characters to strip from start and end of the input string
             */
            this.endRegExp = new RegExp('^[^\\w]+|[^\\w]+$', 'g');
            this.openLeft = false;
            this.openRight = false;
            this.classRegistry = HilitorClassRegistry_1.default.getInstance();
            this.targetNode = targetNode;
            this.hiliteTag = 'MARK';
            this.initSkipTags();
        }
        /**
         * start highlighting at target node
         */
        Hilitor.prototype.apply = function (input) {
            this.remove();
            if (input === undefined) {
                return null;
            }
            input = input.replace(/(^\s+|\s+$)/g, '');
            if (!input) {
                return null;
            }
            input = UnicodeUtility_1.default.escapeUnicode(input);
            input = UnicodeUtility_1.default.removeUnicode(input);
            if (this.setRegex(input)) {
                this.hiliteWords(this.targetNode);
            }
            // build array of matches
            this.matches = this.targetNode.getElementsByTagName(this.hiliteTag);
            // return number of matches
            return this.matches.length;
        };
        Hilitor.prototype.getRegex = function () {
            var retval = this.matchRegExp.toString();
            retval = retval.replace(/(^\/|\(\?:[^)]+\)|\/i$)/g, '');
            return retval;
        };
        /**
         * remove highlighting
         */
        Hilitor.prototype.remove = function () {
            var arr = this.targetNode.getElementsByTagName(this.hiliteTag);
            // tslint:disable:prefer-for-of
            while (arr.length) {
                var el = arr[0];
                if (!el) {
                    break;
                }
                var parent_1 = el.parentNode;
                parent_1.replaceChild(el.firstChild, el);
                parent_1.normalize();
            }
            // tslint:enable:prefer-for-of
            return true;
        };
        Hilitor.prototype.setHiliteTag = function (hiliteTag) {
            this.hiliteTag = hiliteTag;
            this.initSkipTags();
        };
        Hilitor.prototype.setMatchType = function (type) {
            switch (type) {
                case 'left':
                    this.openLeft = false;
                    this.openRight = true;
                    break;
                case 'right':
                    this.openLeft = true;
                    this.openRight = false;
                    break;
                case 'open':
                    this.openLeft = this.openRight = true;
                    break;
                default:
                    this.openLeft = this.openRight = false;
            }
        };
        Hilitor.prototype.gotoMatch = function (idx) {
            if (this.matches[idx]) {
                this.matches[idx].scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
                for (var i = 0; i < this.matches.length; i++) {
                    var matchedNode = this.matches[i];
                    if (matchedNode instanceof HTMLElement) {
                        matchedNode.style.outline = (idx === i) ? '2px solid red' : '';
                    }
                }
                return true;
            }
            return false;
        };
        /**
         * recursively apply word highlighting
         */
        Hilitor.prototype.hiliteWords = function (node) {
            if (node === undefined || !node) {
                return;
            }
            if (!this.matchRegExp) {
                return;
            }
            if (this.skipTags.test(node.nodeName)) {
                return;
            }
            if (node.hasChildNodes()) {
                // tslint:disable:prefer-for-of
                for (var i = 0; i < node.childNodes.length; i++) {
                    this.hiliteWords(node.childNodes[i]);
                }
                // tslint:enable:prefer-for-of
            }
            // NODE_TEXT
            if (node.nodeType !== 3) {
                return;
            }
            var nv = node.nodeValue;
            if (!nv) {
                return;
            }
            var regs = this.matchRegExp.exec(nv);
            if (!regs) {
                return;
            }
            if (!(node instanceof Text)) {
                return;
            }
            var match = document.createElement(this.hiliteTag);
            match.appendChild(document.createTextNode(regs[1]));
            match.classList.add(this.classRegistry.getClassForRegex(regs[1]));
            var after;
            if (regs[0].match(/^\s/)) { // in case of leading whitespace
                after = node.splitText(regs.index + 1);
            }
            else {
                after = node.splitText(regs.index);
            }
            after.nodeValue = after.nodeValue.substring(regs[1].length);
            node.parentNode.insertBefore(match, after);
        };
        Hilitor.prototype.initSkipTags = function () {
            this.skipTags = new RegExp('^(?:' + this.hiliteTag + '|SCRIPT|FORM)$');
        };
        Hilitor.prototype.setBreakRegExp = function (regex) {
            this.breakRegExp = regex;
            return this.breakRegExp;
        };
        Hilitor.prototype.setEndRegExp = function (regex) {
            this.endRegExp = regex;
            return this.endRegExp;
        };
        Hilitor.prototype.setRegex = function (input) {
            input = input.replace(/\\u[0-9A-F]{4}/g, ''); // remove missed unicode
            input = input.replace(this.endRegExp, '');
            input = input.replace(this.breakRegExp, '|');
            input = input.replace(/^\||\|$/g, '');
            input = UnicodeUtility_1.default.addAccents(input);
            if (input) {
                var re = '(' + input + ')';
                if (!this.openLeft) {
                    re = '(?:^|[\\b\\s])' + re;
                }
                if (!this.openRight) {
                    re = re + '(?:[\\b\\s]|$)';
                }
                this.matchRegExp = new RegExp(re, 'i');
                return this.matchRegExp;
            }
            return false;
        };
        return Hilitor;
    }());
    exports.default = Hilitor;
});
